import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CityService } from '../services/city.service';


@Component({
    selector: 'app-feedback',
    templateUrl: './feedbackAlt.component.html',
    styleUrls: ['./feedbackAlt.component.css'],
    providers: []
})
export class FeedbackProComponent implements OnInit {
   
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        
    ) {}
    ngOnInit() {}
}